<template>
    <div>
        <v-navigation-drawer v-model="drawer" app clipped>
            <v-list dense>
                <v-list-item :to="{ name: 'home' }">
                    <v-list-item-action>
                        <v-icon>mdi-view-dashboard</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('leftNavigation.dashboard')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="isAdmin" :to="{ name: 'employees' }">
                    <v-list-item-action>
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('leftNavigation.employees')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'contracts' }">
                    <v-list-item-action>
                        <v-icon>mdi-file-document-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('leftNavigation.contracts')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'requests' }">
                    <v-list-item-action>
                        <v-icon>mdi-account-clock</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('leftNavigation.vacationRequests')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'holidays' }">
                    <v-list-item-action>
                        <v-icon>mdi-account-clock</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('leftNavigation.holidays')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'settings' }">
                    <v-list-item-action>
                        <v-icon>mdi-cog</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t('leftNavigation.settings')
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar color="indigo" dark app clipped-left>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title>
                <router-link :to="{ name: 'home' }">
                    <span>{{ $t('topMenu.title') }}</span>
                </router-link>
            </v-toolbar-title>

            <v-spacer />

            <v-menu v-if="loggedUser" offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn class="profile-icon mr-2" icon v-on="on">
                        <v-img
                            v-if="loggedUser.profileImageMinFilePath"
                            :src="
                                `${mediaUrl}/${loggedUser.profileImageMinFilePath}`
                            "
                        />
                        <span v-else>
                            {{
                                loggedUser.firstName[0] + loggedUser.lastName[0]
                            }}</span
                        >
                    </v-btn>
                </template>
                <v-card class="pt-2">
                    <p class="text-center body-2 mb-1 mx-4"
                        >{{ $t('topMenu.loggedAs') }}<br />
                        <b>{{
                            `${loggedUser.firstName} ${loggedUser.lastName}`
                        }}</b></p
                    >
                    <v-list class="d-flex flex-column align-center">
                        <v-list-item>
                            <v-btn text large :to="{ name: 'profile' }">
                                <span>{{ $t('topMenu.profile') }}</span>
                            </v-btn>
                        </v-list-item>
                        <v-list-item>
                            <v-btn text large @click="onLogout">
                                <span>{{ $t('topMenu.logout') }}</span>
                            </v-btn>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
        </v-app-bar>

        <v-main>
            <v-container v-if="shouldUpdate" fluid class="pb-0">
                <v-alert
                    dense
                    type="warning"
                >
                    <v-row class="pointer" @click="hardReload">
                        New version of the app is available. Click here to reload.
                    </v-row>
                </v-alert>
            </v-container>
            <keep-alive>
                <slot />
            </keep-alive>
        </v-main>

        <v-footer app class="app-footer">
            <span>&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { mediaUrl } from '@/config';

export default {
    props: {
        source: String
    },
    data() {
        return {
            drawer: null,
            mediaUrl
        };
    },
    computed: {
        ...mapGetters({
            loggedUser: 'auth/getLoggedUser',
            isAdmin: 'auth/isAdmin',
            settings: 'settings/getSettings',
            shouldUpdate: 'versions/getShouldUpdate'
        })
    },
    async created() {
        this.$vuetify.theme.dark = this.settings.isThemeDark;
    },
    methods: {
        ...mapActions({
            logout: 'auth/logout'
        }),
        ...mapMutations({ setSettings: 'settings/setSettings' }),

        async onLogout() {
            await this.logout();
            this.setSettings(null);
            this.$vuetify.theme.dark = false;
            this.$router.push({ name: 'login' });
        },

        hardReload() {
            window.location.reload(true);
        }
    }
};
</script>

<style scoped>
.v-app-bar a {
    color: white;
    text-decoration: none;
}
.pointer {
    cursor: pointer
}
</style>
